import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  refreshData(event) {
    const frame = document.getElementById("main-dashboard")
    frame.reload()
  }
}
